<template>
  <transition name="fade" mode="out-in">
    <div
      v-if="pageLoading"
      class="flex justify-center"
      style="height: 100vh"
      key="loader"
    ></div>
    <div v-else id="menu" class="container md:overflow-y-scroll overscroll-contain" key="content">
      <div v-if="hasKiosk" class="flex flex-wrap text-center justify-center md:justify-start">
        <div class="w-full">
          <!-- <div class="flex justify-center md:hidden">
            <img
              v-if="menu.picture_url"
              class="h-24 rounded-lg"
              :src="
                menu.picture_url
                  ? menu.picture_url
                  : require('../assets/images/Menu.Logo.png')
              "
              alt="Logo"
            />
          </div> -->
        </div>
      </div>
      <!-- nav -->
      <div>
        <Category
        :infiniteScroll="infiniteScroll"
        @category-changed="(item)=>$emit('category-changed',item)"
         />
      </div>

      <!-- <div class="flex flex-col mt-3 ml-4">
        <div class="flex flex-wrap">
          <div></div>
          <div class="flex items-center">
            <svg
              :class="[
                'inline-block h-8 w-8',
                'text-' + theme.body.selectedItem,
              ]"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
              />
            </svg>
          </div>
          <div class="text-gray-700 text-center py-2 m-2 text-primary">
            {{ lang["Home"][language] }}
          </div>
        </div>
        <div class="flex flex-wrap">
          <div class="flex items-center">
            <svg
              :class="['inline-block h-8 w-8']"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
              />
            </svg>
          </div>
          <div class="text-gray-700 text-center py-2 m-2">
            {{ lang["Menu"][language] }}
          </div>
        </div>
        <div class="flex flex-wrap">
          <div class="flex items-center">
            <svg
              :class="['inline-block h-8 w-8']"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z"
              />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z"
              />
            </svg>
          </div>
          <div class="text-gray-700 text-center py-2 m-2">
            {{ lang["Discount"][language] }}
          </div>
        </div>
      </div>-->
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import lang from "../lang";
import moment from "moment";
import Category from "../views/Category";

export default {
  components: {
    Category,
  },
  data() {
    return {
      buttonSpinner: false,
      userProvidedMenuHash: "",
      errorMessage: "",
      lang: lang,
    };
  },
  computed: {
    ...mapGetters([
      "infiniteScroll",
      "pageLoading",
      "language",
      "menu",
      "menuItems",
      "theme",
      "menuHash",
      "isMobileDevice",
      "menuCategories",
      "currentKioskMode",
      "hasKiosk",
      "categoryId",
      "subCategoryId",
    ]),
    ...mapGetters("Cart", ["timeSlots", "selectedTimeSlot"]),
    selectedTimeSlot: {
      get() {
        let result = this.$store.getters["Cart/selectedTimeSlot"];
        if (result != "") {
          return moment(result)
            .lang(this.language)
            .format("dddd Do MMM");
        } else {
          return "";
        }
      },
    },
  },
  methods: {
    changeActiveMenuCategory(categoryId){
      let item=this.menuCategories.find(el=>el.Id==categoryId);
      this.$store.commit("updateSelectedMenuCategory", item);
    },
    getCategories(item) {
      this.$store.commit("updateSelectedMenuCategory", item);
      this.$store.commit("updateCategoryId", item.Id);
      this.$store.commit("updateIsSubSubCategory", false);
      if (item.hasSubCategories) {
        this.$store.commit("updateSubCategoryId", item.Id);
        this.$store.dispatch("GET_MENU_SUB_CATEGORIES");
        this.$store.commit("updateMenuCategoriesCategories", item);

        this.$router
          .push("/" + this.$route.params.menuHash + "/category/" + item.Id)
          .catch(() => {});
      } else {
        this.$store.dispatch("GET_CATEGORY");
        this.$router
          .push("/" + this.$route.params.menuHash + "/sub/category/" + item.Id)
          .catch(() => {});
      }
    },
    /**
     * Fetch The Menus.
     *
     * @return void
     */
    getMenus() {
      if(this.hasKiosk){
      this.$store
        .dispatch("GET_MENU_ITEMS")
        .then((response) => {
          /**
           * Checking if theme doesn't exists on the local storage then
           * storing the theme and reloading the page again to reflect the
           * theme in all the part of the website.
           */
          if (localStorage.getItem("theme") == null) {
            if (response.data.Menu.design) {
              this.$store.commit("setCurrentTheme", response.data.Menu.design);
              location.reload();
            }
          }
          /**
           * If User has changed the theme then it will update the theme and
           * reload the page to reflect all part of the website.
           */
          if (localStorage.getItem("theme") != response.data.Menu.design) {
            this.$store.commit("setCurrentTheme", response.data.Menu.design);
            location.reload();
          }

          if (this.isMobileDevice === false) {
            this.$router
              .push(
                "/" +
                  this.menuHash +
                  "/sub/category/" +
                  this.menuCategories[0].Id
              )
              .catch(() => {});
            this.$store.commit("updateCategoryId", this.menuCategories[0].Id);
            this.$store.dispatch("GET_CATEGORY");
          }

          this.buttonSpinner = false;
        })
        .catch((error) => {
          this.buttonSpinner = false;
          if (error.response.status == 404) {
            this.errorMessage = "Please enter valid Menu Code";
          }
        });
        if (this.categoryId) {
        this.$store.dispatch("GET_CATEGORY");
      }

      }
      else{
         // this.$store
      //   .dispatch("GET_CORRECT_MENU_ITEMS")
      //   .then((response) => {
          /**
           * Checking if theme doesn't exists on the local storage then
           * storing the theme and reloading the page again to reflect the
           * theme in all the part of the website.
           */
          // if (localStorage.getItem("theme") == null) {
          //   if (response.data.Menu.design) {
          //     this.$store.commit("setCurrentTheme", response.data.Menu.design);
          //     location.reload();
          //   }
          // }
          /**
           * If User has changed the theme then it will update the theme and
           * reload the page to reflect all part of the website.
           */
          // if (localStorage.getItem("theme") != response.data.Menu.design) {
          //   this.$store.commit("setCurrentTheme", response.data.Menu.design);
          //   location.reload();
          // }

          if (this.isMobileDevice === false) {
            this.$router
              .push(
                "/" +
                  this.menuHash +
                  "/sub/category/" +
                  this.menuCategories[0].Id
              )
              .catch(() => {});
            this.$store.commit("updateCategoryId", this.menuCategories[0].Id);
            // this.$store.dispatch("GET_CATEGORY");
          }
          setTimeout(() => {
            this.$emit('category-changed',this.categoryId||this.subCategoryId);
          }, 500);


          this.buttonSpinner = false;
        // })
        // .catch((error) => {
        //   this.buttonSpinner = false;
        //   if (error.response.status == 404) {
        //     this.errorMessage = "Please enter valid Menu Code";
        //   }
        // });
      if (this.categoryId||this.subCategoryId) {
        /** If subCategoryId is set then update subCategoryId to CategoryId and open 
         * menu list of sub category */
        if(this.subCategoryId){
          this.$store.commit('updateCategoryId',this.subCategoryId)
          this.$store.commit("updateIsCategorySubItem", true);
        }
      }
      }
    },
  },
  mounted() {
    /**
     * If the link has the MenuHash it will get the Menu Hash details.
     *
     * Else it will hide the page loader and update the `menuHasAvailable`
     * to false so that it can show up input field to ask user for menuHash.
     */
    if (this.$route.params.menuHash) {
      if (Object.keys(this.menu).length == 0) {
        /**
         * Going to make call to getMenus API if the menu Hash has 5 chars.
         */
        if (this.$route.params.menuHash.length >= 5) {
          this.$store.commit("updateMenuHash", this.$route.params.menuHash);
          if(this.hasKiosk){

            this.getMenus();
          }else{
            this.$store.dispatch("GET_CORRECT_MENU_ITEMS").then((response)=>{
          if(this.infiniteScroll){
          if(!this.menuItems.length&&!this.$store.getters.loadingItems){
              this.getAllMenus(response);
            }
          }else{
            this.getMenus(response);
          }
          }).catch((error) => {
          this.buttonSpinner = false;
          if (error.response.status == 404) {
            this.errorMessage = "Please enter valid Menu Code";
          }
        });
          }
        }
      }
    } else {
      this.$store.commit("stopPageLoading");
    }
  },
  created() {

  },
};
</script>
